import { listItemToSnapshot } from "../api/landingClass.mappers";
import { getClassesByLevelService } from "../api/landingClass.service";
import type { ClassListSnapshot } from "../api/landingClass.types";
import { resolveLevel1IdForLevel2 } from "./resolveLevel1Id";

const PER_PAGE = 50;

/**
 * Loads list-card stats (units, videos, badge) when the view API omits them.
 * Paginates the by-level catalog until the class id is found.
 */
export async function resolveClassListSnapshot(
  level2Id: string,
  classId: string,
  level1Id?: string
): Promise<ClassListSnapshot | null> {
  if (!level2Id || !classId) return null;

  const resolvedLevel1Id = await resolveLevel1IdForLevel2(level2Id, level1Id);
  if (!resolvedLevel1Id) return null;

  let page = 1;

  for (;;) {
    const response = await getClassesByLevelService(level2Id, {
      level1Id: resolvedLevel1Id,
      page,
      pageSize: PER_PAGE,
    });
    const items = response.data ?? [];
    const match = items.find((item) => item.id === classId);
    if (match) {
      return listItemToSnapshot(match);
    }

    const totalPages = response.pageInfo?.total_pages ?? 1;
    if (page >= totalPages || items.length === 0) {
      return null;
    }
    page += 1;
  }
}
